<!-- Tab headers -->
<nav class="headers">
    <button
        class=""
        *ngFor="let tab of tabs; let i = index"
        (click)="activeIndex = i"
        [class.active]="i === activeIndex">
        {{ tab.title }}
    </button>
  </nav>

<!-- Active body -->
<ng-container
    *ngIf="tabArray.length"
    [ngTemplateOutlet]="tabArray[activeIndex].tplRef">
</ng-container>